module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CxKwOE/tc-custom/9781626811560.jpg?1728851724830",
      "alt": "This image is the cover for the book Tarnished Hearts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tarnished Hearts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The national-bestselling romance author and “one of the superstars of western romance” spins a lush tale of fate and desire at the start of the Civil War ("), _c('i', [_vm._v("Affaire de Coeur")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Tormented by his past and denied his dream of becoming a doctor, Southern aristocrat Trevor Shelby has little in his life to live for, until he meets the beautiful overseer’s daughter, Leah Reese."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Unused to the warmth and kindness Leah shows him, Trevor learns to love from the young woman, while his intensity teaches her the value of passion. Despite the difference in their social classes, they dare to dream of a future together . . . until that fantasy is shattered by lies, betrayal, and the outbreak of war."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" And even as Leah is wed to a man she does not love, Trevor refuses to give up on her, following her into the new frontier of the American West—where danger and destiny will bring them together once more . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Raine Cantrell\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0